angular.module('locationListDirectiveModule', []).directive('locationList', ['loginService', 'globleParamsSet', 'trsHttpService', function(loginService, globleParamsSet, trsHttpService) {
    return {
        scope: {
            areaCode: '=',
            isShow: '=',
            callback: '&',
        },
        templateUrl: './editingCenter/directive/supportCreation/directive/locationList/index.html',
        replace: true,
        restrict: 'E',
        link: function($scope, iElm) {
            initStatus();
            inintData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.data = {
                    locationArray: [],
                };
            }

            /**
             * [inintData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function inintData() {
                getLocationList();
                initHide();
            }

            /**
             * [getLocationList description]根据当前登录人的信息 获取token，获取其他地区
             * @return  {[type]}  [return description]
             */
            function getLocationList() {
                loginService.getCurrLoginUser().then(function(user) {
                    var params = {
                        tenantId: user.TENANTID,
                    };
                    globleParamsSet.getTokenService(user.TENANTID).then(function(token) {
                        trsHttpService.httpServer('/api/tenantcenter/region/getTopLayerRegion', params, 'get', '', {
                            token: token.token,
                        }).then(function(data) {
                            $scope.data.locationArray = data.datas;
                        });
                    });
                });
            }

            /**
             * [search description] 点击地点选中回调函数
             * @param   {[type]}  item  [item description] 选中的地点对象
             * @return  {[type]}        [return description]
             */
            $scope.selected = function(item) {
                $scope.isShow = false;
                $scope.callback()(item);
            };

            /**
             * [initElementEvent description] 初始化聚焦失焦事件
             * @return {[type]} [description]
             */
            function initHide() {
                var hide = function(e) {
                    var $target = $(e.target);
                    if ($target[0] !== iElm[0]) {
                        $scope.isShow = false;
                    }
                };
                $('body').bind('mouseup', hide);
                $scope.$on('$destroy', function() {
                    $('body').unbind('mouseup', hide);
                });
            }
        },
    };
}, ])
;
